import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CheckAliasValidator } from '../../validators/check-alias.validator';
import { Mailbox } from '../../models/mailboxes.model';
import { ProximusMailboxPattern } from '../../config/my-mail.config';
import { Observable } from 'rxjs';

@Component({
  selector: 'mprd-create-alias',
  templateUrl: 'create-alias.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateAliasComponent implements OnInit, OnChanges {
  showLoadingSpinner: boolean;
  @Input() mailbox: Mailbox;
  @Input() showLoadingSpinner$: Observable<boolean>;
  @Output() createMailAlias: EventEmitter<any> = new EventEmitter();
  createAliasForm: UntypedFormGroup;
  isAliasAvailable: boolean;
  isAliasFormHasErrors: boolean;

  constructor(
    private builder: UntypedFormBuilder,
    private checkAliasValidator: CheckAliasValidator,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.createAliasForm = this.builder.group(
      {
        alias: [
          '',
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            Validators.pattern(ProximusMailboxPattern),
            this.checkAliasValidator.whiteSpaceCheck(),
            this.checkAliasValidator.atSignCheck(),
          ],
        ],
        domain: this.mailbox.availableDomains
          ? this.mailbox.availableDomains[0]
          : '',
      },
      {
        asyncValidator: this.checkAliasValidator.checkAlias('alias', 'domain'),
      },
    );

    this.createAliasForm.statusChanges.subscribe(() => {
      if (!this.createAliasForm.pending) {
        this.changeDetector.markForCheck();
      }

      const isAliasFieldValidated =
        !this.createAliasForm.pending &&
        this.createAliasForm.controls['alias'].dirty; // &&
      // this.createAliasForm.controls['alias'].value.length >= 5;
      this.isAliasAvailable =
        isAliasFieldValidated && this.createAliasForm.valid;
      this.isAliasFormHasErrors =
        isAliasFieldValidated && !this.createAliasForm.valid;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showLoadingSpinner$.subscribe((bool: boolean) => {
      if (bool === false) {
        this.changeDetector.markForCheck();
        this.showLoadingSpinner = false;
      }
    });
    if (this.createAliasForm) {
      this.resetForm();
    }
  }

  createAlias() {
    this.showLoadingSpinner = true;
    this.createMailAlias.emit(
      `${this.createAliasForm.value.alias}@${this.createAliasForm.value.domain}`,
    );
    this.resetForm();
  }

  resetForm() {
    this.createAliasForm.reset({
      alias: '',
      domain: this.mailbox.availableDomains[0],
    });
  }

  isAliasEmpty() {
    return this.createAliasForm.value.alias?.length === 0;
  }
}
